import React from "react";
import {
  HiOutlineCheckCircle,
  HiOutlineArrowTopRightOnSquare,
} from "react-icons/hi2";
import { IOnboardingStep } from "../../hooks";
import "./onboarding-card.scss";

interface IOnboardingStepsProps {
  steps: IOnboardingStep[];
  completed: number;
  total: number;
}

/**
 * Shared onboarding content (progress head + step list).
 * Used both by the dashboard card and the sidebar popup.
 */
export const OnboardingSteps = ({
  steps,
  completed,
  total,
}: IOnboardingStepsProps): JSX.Element => {
  const pct = Math.round((completed / total) * 100);

  return (
    <>
      <div className="onboarding-card__head">
        <div className="onboarding-card__head-text">
          <h3 className="onboarding-card__title">Finish setting up Upwex</h3>
          <p className="onboarding-card__subtitle">
            A couple of minutes to start winning more jobs.
          </p>
        </div>
        <div className="onboarding-card__progress">
          <div className="onboarding-card__progress-bar">
            <span style={{ width: `${pct}%` }} />
          </div>
          <span className="onboarding-card__progress-label">
            {completed}/{total}
          </span>
        </div>
      </div>

      <div className="onboarding-card__steps">
        {steps.map((step, i) => (
          <div
            key={step.key}
            className={`onboarding-card__step ${step.done ? "onboarding-card__step--done" : ""}`}
          >
            <span className="onboarding-card__step-marker">
              {step.done ? (
                <HiOutlineCheckCircle size={22} />
              ) : (
                <span className="onboarding-card__step-num">{i + 1}</span>
              )}
            </span>
            <div className="onboarding-card__step-text">
              <span className="onboarding-card__step-title">{step.title}</span>
              <span className="onboarding-card__step-desc">
                {step.description}
              </span>
            </div>
            {!step.done && (
              <button
                className="onboarding-card__step-cta"
                onClick={step.onAction}
              >
                {step.ctaLabel}
                <HiOutlineArrowTopRightOnSquare size={15} />
              </button>
            )}
          </div>
        ))}
      </div>
    </>
  );
};

export default OnboardingSteps;
